import { api } from '../client';

export interface AccessObject {
  id: string;
  code: string;
  roleId: string;
  conditions?: Record<string, unknown>;
}

export interface Role {
  id: string;
  code: string;
  name: string;
  description?: string;
  isSystem: boolean;
  companyId?: string;
  accessObjects: AccessObject[];
  _count?: {
    userRoles: number;
  };
  createdAt: string;
  updatedAt: string;
}

export interface CreateRoleDto {
  code: string;
  name: string;
  description?: string;
  isSystem?: boolean;
  companyId?: string;
  accessObjectCodes?: string[];
}

export const rolesApi = {
  async getAll(includeSystem = true) {
    const response = await api.get<Role[]>('/roles', {
      params: { includeSystem },
    });
    return response.data;
  },

  async getById(id: string) {
    const response = await api.get<Role>(`/roles/${id}`);
    return response.data;
  },

  async create(data: CreateRoleDto) {
    const response = await api.post<Role>('/roles', data);
    return response.data;
  },

  async update(id: string, data: Partial<CreateRoleDto>) {
    const response = await api.patch<Role>(`/roles/${id}`, data);
    return response.data;
  },

  async delete(id: string) {
    const response = await api.delete(`/roles/${id}`);
    return response.data;
  },

  async assignAccessObjects(roleId: string, codes: string[]) {
    const response = await api.post<Role>(`/roles/${roleId}/access-objects`, {
      codes,
    });
    return response.data;
  },

  async removeAccessObject(roleId: string, code: string) {
    const response = await api.delete<Role>(
      `/roles/${roleId}/access-objects/${encodeURIComponent(code)}`
    );
    return response.data;
  },
};
